import { render, staticRenderFns } from "./mealTicket.vue?vue&type=template&id=8fc71460&scoped=true"
import script from "./mealTicket.vue?vue&type=script&lang=js"
export * from "./mealTicket.vue?vue&type=script&lang=js"
import style0 from "./mealTicket.vue?vue&type=style&index=0&id=8fc71460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc71460",
  null
  
)

export default component.exports